import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { getAllEmotionalCorrelations, EmotionalCorrelationResult } from '@/utils/emotionalCorrelations';

export function useEmotionalCorrelations(days: number = 60) {
  const [correlations, setCorrelations] = useState<EmotionalCorrelationResult[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCorrelations = async () => {
      setIsLoading(true);
      setError(null);
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        setError('Please sign in to view emotional correlations');
        setIsLoading(false);
        return;
      }

      try {
        const results = await getAllEmotionalCorrelations(user.id, days);
        setCorrelations(results);
      } catch (err) {
        console.error('Error fetching emotional correlations:', err);
        setError('Failed to load emotional correlations');
      }
      
      setIsLoading(false);
    };

    fetchCorrelations();
  }, [days]);

  return { correlations, isLoading, error };
}
